import { home } from '@/lang/en/pages/home.ts'
import { pricing } from '@/lang/en/pages/pricing.ts'

import { manager } from '@/lang/en/pages/products/manager.ts'
import { page } from '@/lang/en/pages/products/page.ts'
import { pos } from '@/lang/en/pages/products/pos.ts'
import { qr } from '@/lang/en/pages/products/qr.ts'
import { webshop } from '@/lang/en/pages/products/webshop.ts'

import { lunchroom } from '@/lang/en/pages/cases/lunchroom.ts'
import { cafetaria } from '@/lang/en/pages/cases/cafetaria.ts'
import { grillroom } from '@/lang/en/pages/cases/grillroom.ts'
import { sushi } from '@/lang/en/pages/cases/sushi.ts'
import { italian } from '@/lang/en/pages/cases/italian.ts'

import { support } from '@/lang/en/pages/info/support.ts'
import { faq } from '@/lang/en/pages/info/faq.ts'
import { downloads } from '@/lang/en/pages/info/downloads.ts'
import { integrations } from '@/lang/en/pages/info/integrations.ts'

export const pages = {
  home,
  products: {
    manager,
    page,
    pos,
    qr,
    webshop
  },
  pricing,
  cases: {
    lunchroom,
    cafetaria,
    grillroom,
    sushi,
    italian
  },
  info: {
    support,
    faq,
    downloads,
    integrations
  },
}